import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { concat, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { FieldType } from '@ngx-formly/core';
import { AccountMembership, APIService, EntityList, ListCreationType, SearchableContactFilterInput, SearchableEntityListFilterInput, SearchableEntityListSortableFields, SearchableEntityListSortInput, SearchableSortDirection } from '../../../API.service.custom';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from '../../../../services/data-share.service';
import { LeadTag } from 'globals/constants';
import { NgSelectComponent, NgLoadingSpinnerTemplateDirective } from '@ng-select/ng-select';
import { NgClass, AsyncPipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
    selector: 'app-select-lead-tag',
    templateUrl: './select-lead-tag.component.html',
    styleUrls: ['./select-lead-tag.component.scss'],
    imports: [NgSelectComponent, NgClass, ExtendedModule, FormsModule, NgxIntlTelInputModule, NgLoadingSpinnerTemplateDirective, AsyncPipe]
})
export class SelectLeadTagComponent extends FieldType implements OnInit {
  @Input() dropdownPosition = 'bottom';

  @Input() parentFilter = null;

  people$: Observable<any[]>;
  peopleLoading = false;
  peopleInput$ = new Subject<string>();


  @Input() placeholder: string = "Select Lead Tag";
  @Input() allowAdding: boolean = false;
  @Input() allowMultiple: boolean = false;
  @Input() preSelectedContact: any = null;
  @Input() readonly: boolean = false;
  @Input() cssClass : string = "entity-selector";
  @Output() selectedLeadTag = new EventEmitter();
  @Input() appendTo = undefined;

  activAccountSubscription;
  activeAccount: AccountMembership = null;

  leadTagsSubscription;
  leadTags: LeadTag[] = [];
  modifiedLeadTags : any[] = [];

  selectedContact: any | any[] = null;

  searchTerm : string = null;


  constructor(private api: APIService, private toastr: ToastrService, private dataService: DataShareService,) {
    super();
  }

  ngOnInit() {
    if (this.field && this.props) {
      if (this.props.placeholder !== undefined && this.props.placeholder !== null && this.props.placeholder !== "") {
        this.placeholder = this.props.placeholder;
      }
      
      if (this.props.multiple1 !== undefined && this.props.multiple1 !== null) {
        this.allowMultiple = this.props.multiple1;
      }
      
      if (this.props.allowAdding !== undefined && this.props.allowAdding !== null) {
        this.allowAdding = this.props.allowAdding;
      }

      if (this.props.cssClass !== undefined && this.props.cssClass !== null) {
        this.cssClass = this.props.cssClass;
      }
      
      if (this.props.readonly !== undefined && this.props.readonly !== null) {
        this.readonly = this.props.readonly;
      }
      if (this.props.preSelectedContact !== undefined && this.props.preSelectedContact !== null) {
        this.preSelectedContact = this.props.preSelectedContact;
      }
    } 
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("+++++++++++++ The active account is :", this.activeAccount)
        this.leadTagsSubscription = this.dataService.getLeadTags().subscribe((tags_param: any) => {
          console.log("in contacts component, Lead Tags are ", tags_param);
          if (tags_param) {
            this.leadTags = tags_param;
            if(this.leadTags && this.leadTags.length > 0){
              this.modifiedLeadTags = this.leadTags.map(item => ({
                key: item.value
              }));
            }
            this.loadPeople();
          }
        });
      }
      })
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("preselected contact is :", this.preSelectedContact)
    if (this.preSelectedContact && (!this.selectedContact || this.selectedContact.length == 0)) {
      console.log("setting contact preselection");
      if (this.allowMultiple){
        if(Array.isArray(this.preSelectedContact))
          this.selectedContact = this.preSelectedContact;
        else
          this.selectedContact = [this.preSelectedContact];
      }
      else
        this.selectedContact = this.preSelectedContact;
      this.selectedLeadTag.emit(this.selectedContact);
    }
    else if ((!this.preSelectedContact || this.preSelectedContact?.length == 0) && ((this.allowMultiple && this.selectedContact?.length > 0) || (!this.allowMultiple && this.selectedContact))) {
      if (this.allowMultiple)
        this.selectedContact = [];
      else
        this.selectedContact = null;
      this.selectedLeadTag.emit(this.selectedContact);
    }
  }

  // trackByFnPeople(item: EntityList) {
  //   return item.id
  // }

  private loadPeople() {
    this.people$ = concat(
      of([]), // default items
      this.peopleInput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.peopleLoading = true),
        tap(term => this.searchTerm = <any>term),
        switchMap(term => this.searchContact(term, "userDefinedTags").pipe(
          catchError(() => of([])), // empty list on error
          map(searchResults => {
            const filteredModifiedLeadTags = this.applySearchTerm(this.modifiedLeadTags, term);
            const combinedResults = [...filteredModifiedLeadTags, ...searchResults];  
            const uniqueResults = this.removeDuplicates(combinedResults, 'key');
            return uniqueResults;
          }),
          tap(() => this.peopleLoading = false)
        ))
      )
    );
  }

  private applySearchTerm(items: { key: string }[], term: string): { key: string }[] {
    if (!term) {
      return items; // Return all items if no search term is provided
    }
    return items.filter(item =>
      item.key.toLowerCase().includes(term.toLowerCase()) // Case-insensitive search
    );
  }

  private removeDuplicates(array: { key: string }[], key: string): { key: string }[] {
    const seen = new Set();
    return array.filter(item => {
      const value = item[key];
      if (seen.has(value)) {
        return false; // Skip duplicates
      }
      seen.add(value);
      return true;
    });
  }

  searchContact(term : string, field : string) : Observable<any[]>{
    let f = <SearchableContactFilterInput>{};
    if(this.parentFilter){
      f = JSON.parse(this.parentFilter)
    }
    else{
      f.accountId = { eq: this.activeAccount?.accountId }
      if (this.activeAccount.authorizationLevel == "MEMBER")
        f.ownerId = { eq: this.activeAccount.userId };
    }
    
    if(field == 'contactSourceDrillDownOne' && this.selectedContact)
      f.contactSource = {eq : this.selectedContact.key}
    
    let searchFilter = <SearchableContactFilterInput>{}
    if (term && term != '') {
      let newTerm = '*' + term.toLowerCase() + '*';
      searchFilter[field] = { wildcard: newTerm };
      f = { and: [f, searchFilter] }
    }
    return from(this.api.AggregateSearchableQuery(this.activeAccount.accountId, "Contact", JSON.stringify(f), null, field, "count")).pipe(map(
      response => 
        {
          let parsedData = JSON.parse(response);
          return parsedData.aggregations[field].buckets;
        }
      ))
  }

  onTagSelectChange(event) {
    console.log("selection changed: added ", event);
    if (event) {
      this.selectedLeadTag.emit(event);
      if (this.field && this.field.templateOptions) {
        if (Array.isArray(event)) {
          let keys = event.map(item => item.key);
          this.formControl.setValue(keys)
        }
        else{
          this.formControl.setValue(event.key)
        }
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
    }
  }

  onTagSelectRemove(event) {
    console.log("selection removed: removed ", event);
      this.selectedLeadTag.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(null)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
  }

}

